import { number2text, text2number } from 'core/utils';

export default {
  props: {
    value: {
      type: [Number, String],
      default: undefined,
      validator(value) {
        if (value === undefined || value === null) {
          return true;
        }

        if (typeof value === 'string' && value === 'NaN') {
          return true;
        }

        return typeof value === 'number';
      }
    },

    precision: {
      type: Number,
      default: 2
    },

    min: {
      type: Number,
      default: undefined
    },

    max: {
      type: Number,
      default: undefined
    },

    decimalSeparator: {
      type: String,
      default: undefined
    },

    thousandSeparator: {
      type: String,
      default: undefined
    }
  },

  methods: {
    number2text(value) {
      const ret = number2text(value, this.precision, this.thousandSeparator, this.decimalSeparator);
      //console.log('number2text(', value, ') =', ret);
      return ret;
    },

    text2number(value) {
      const ret = text2number(value);
      // console.log('text2number(', value, ') =', ret);
      return ret;
    }
  }
};
